module.exports = __webpack_public_path__ + "images/emails/i-email-stats@2x-65e670f3.png";